<template>
  <div>
    <div class="mt-3 bg-white-border p-3">
      <b-row class="no-gutters my-3">
        <b-col md="4" cols="12" class="d-flex align-items-center">
          <p class="font-weight-bold f-20 my-auto">
            Unknown Keyword Suggestion
          </p>
        </b-col>
        <b-col md="8" cols="12" class="custom-filter d-flex">
          <div class="time-filter d-flex">
            <div class="my-auto">Intent:</div>
            <div class="ml-2 my-auto">
              <b-form-select
                v-model="filter.intentTypeId"
                :options="intentTypes"
                class="master-filter"
                value-field="id"
                text-field="name"
                disabled-field="notEnabled"
                @change="onfilterChange"
              ></b-form-select>
            </div>
          </div>
          <div class="time-filter d-flex ml-0 ml-sm-2">
            <div class="my-auto">Time:</div>
            <div class="ml-2 my-auto">
              <b-form-select
                v-model="filter.FilterDay"
                :options="masterFilterList"
                class="master-filter"
                value-field="value"
                text-field="name"
                disabled-field="notEnabled"
                @change="onfilterChange"
              ></b-form-select>
            </div>
          </div>
          <div class="d-flex align-item-center justify-content-center ml-4">
            <b-button class="button-export" @click="exportSuggestKeyword"
              >Export to Excel</b-button
            >
          </div>
          <div class="language-filter my-auto ml-0 ml-sm-4">
            <b-button-group class="btn-language">
              <b-button
                :class="{ active: filter.LanguageId == 1 }"
                @click="onLanguageChange(1)"
                >TH</b-button
              >
              <b-button
                :class="{ active: filter.LanguageId == 2 }"
                @click="onLanguageChange(2)"
                >EN</b-button
              >
            </b-button-group>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <p class="font-weight-bold">Top Keyword</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col class=""
          ><div
            class="bg-white bar-progress-container"
            v-if="filteredBarlists.length > 0"
          >
            <BarProgressList
              :groupList="filteredBarlists"
              v-on:handleCreateIntent="handleCreateIntent"
              v-on:onRemoveGroupKeyword="onRemoveGroupKeyword"
            />
          </div>
          <div
            v-else
            class="
              bg-white
              card
              text-dark
              p-3
              bar-progress-container
              d-flex
              align-items-center
            "
          >
            <div class="m-auto">
              <span class="font-weight-bold">ไม่พบข้อมูล</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <SidebarIntent
      ref="sidebarIntent"
      :form="form"
      :languageList="languageList"
      :languageActiveId="languageActiveId"
      :sentimentActiveId="sentimentActiveId"
      :isSentiment="isSentiment"
      :intentLevel="intentLevel"
      :v="$v"
      :intentTypeList="intentTypeList"
      v-bind:channelList="channelList"
      v-bind:tierList="tierList"
      v-on:createOrUpdateIntent="createOrUpdateIntent"
      v-on:setLanguageAvtive="setLanguageAvtive"
      v-on:setSentimentActive="setSentimentActive"
      v-on:setIsSentiment="setIsSentiment"
      v-on:onIntentTypeChange="onIntentTypeChange"
    />
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalErrorMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import BarProgressList from "@/views/pages/chat-analysis/components/BarProgressList";
import SidebarIntent from "@/views/pages/flow-builder/components/sidebar/SidebarIntent";
import { required, requiredIf } from "vuelidate/lib/validators";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import moment from "moment";

const validateMaxLength = (validateFlag, item) => {
  if (!validateFlag && item.length > 40) {
    return false;
  } else {
    return true;
  }
};
export default {
  components: {
    BarProgressList,
    SidebarIntent,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  name: "UnknownKeyword",
  data() {
    return {
      modalMessage: "",
      modalErrorMessage: "",
      imgModals: null,
      msgModals: null,
      filter: {
        intentTypeId: 2,
        LanguageId: 1,
        FilterDay: 1,
        brandId: parseInt(this.$route.query.brandID),
      },
      intentTypes: [{ id: 2, name: "Fallback" }],
      masterFilterList: [
        { id: 1, name: "Last 1 Days", value: 1 },
        { id: 2, name: "Last 7 Days", value: 7 },
        { id: 3, name: "Last 1 Month", value: 30 },
      ],
      groupList: [],
      intentLevel: 0,
      languageList: [
        {
          id: 1,
          name: "TH",
          isActive: true,
        },
        {
          id: 2,
          name: "EN",
          isActive: true,
        },
      ],
      languageActiveId: 1,
      sentimentActiveId: 1,
      isSentiment: false,
      intentTypeList: [],
      form: {
        active: true,
        enableML: false,
        intentTypeId: 1,
        mainIntentId: 0,
        intentButtonId: 0,
        forwardToAgent: false,
        image: [],
        channel: [],
        tier: [],
        // brandId: parseInt(this.$route.query.brandID),
        intent: [
          {
            intentId: 0,
            language: 1,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 1,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 1,
                  },
                },
              },
            ],
          },
          {
            intentId: 0,
            language: 2,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 2,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 2,
                  },
                },
              },
            ],
          },
        ],
      },
      channelList: [],
      tierList: [],
      idGroupKeyword: {
        groupId: "",
        // brandId: parseInt(this.$route.query.brandID),
      },
    };
  },
  validations: {
    form: {
      image: {},
      channel: { required },
      tier: { required },
      intent: {
        $each: {
          keyword: {
            required: requiredIf(function(item) {
              return (
                item.language == this.languageActiveId &&
                this.form.intentTypeId == 1
              );
            }),
          },
          name: {
            required: requiredIf(function(item) {
              return item.language == this.languageActiveId;
            }),
          },
          // [1] = type Text,  [2] = type Text/Button, [3] = type Text/Image, [4] = type Image, [5] = type Text/Image/Button
          neutralReply: {
            $each: {
              content: {
                Text: {
                  Text: {
                    required: requiredIf(function(item) {
                      var validateFlag = this.form.intent.some((intent) => {
                        return intent.neutralReply.some((reply) =>
                          [1, 2, 3, 5].includes(reply.content.ReplyType)
                        );
                      });

                      return (
                        item &&
                        item.language == this.languageActiveId &&
                        validateFlag
                      );
                    }),
                  },
                },
                Button: {
                  $each: {
                    Label: {
                      required: requiredIf(function(item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.neutralReply.some((reply) =>
                            [2, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag
                        );
                      }),
                      validateMaxLength(item) {
                        var statusCondition = this.form.intent.some(
                          (intent) => {
                            return intent.neutralReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          }
                        );
                        var validateFlag =
                          item &&
                          item.language == this.languageActiveId &&
                          statusCondition;

                        return validateMaxLength(validateFlag, item);
                      },
                    },
                    Data: {
                      required: requiredIf(function(item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.neutralReply.some((reply) =>
                            [2, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag
                        );
                      }),
                    },
                  },
                },
                Image: {
                  required: requiredIf(function(item) {
                    return (
                      item.ReplyType == 4 &&
                      item.language == this.languageActiveId
                    );
                  }),
                  ImageUrl: {
                    required: requiredIf(function(item) {
                      var validateFlag = this.form.intent.some((intent) => {
                        return intent.neutralReply.some((reply) =>
                          [3, 5].includes(reply.content.ReplyType)
                        );
                      });
                      return (
                        item &&
                        item.language == this.languageActiveId &&
                        validateFlag
                      );
                    }),
                  },
                },
              },
            },
          },
          negativeReply: {
            $each: {
              content: {
                Text: {
                  Text: {
                    required: requiredIf(function(item) {
                      var validateFlag = this.form.intent.some((intent) => {
                        return intent.negativeReply.some((reply) =>
                          [1, 2, 3, 5].includes(reply.content.ReplyType)
                        );
                      });

                      return (
                        item &&
                        item.language == this.languageActiveId &&
                        validateFlag &&
                        item.sameReplyAsNeutral == false
                      );
                    }),
                  },
                },
                Button: {
                  $each: {
                    Label: {
                      required: requiredIf(function(item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.negativeReply.some((reply) =>
                            [2, 5].includes(reply.content.ReplyType)
                          );
                        });

                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag &&
                          item.sameReplyAsNeutral == false
                        );
                      }),
                      validateMaxLength(item) {
                        var statusCondition = this.form.intent.some(
                          (intent) => {
                            return intent.neutralReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          }
                        );
                        var validateFlag =
                          item &&
                          item.language == this.languageActiveId &&
                          statusCondition &&
                          item.sameReplyAsNeutral == false;

                        return validateMaxLength(validateFlag, item);
                      },
                    },
                    Data: {
                      required: requiredIf(function(item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.negativeReply.some((reply) =>
                            [2, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag &&
                          item.sameReplyAsNeutral == false
                        );
                      }),
                    },
                  },
                },
                Image: {
                  required: requiredIf(function(item) {
                    return (
                      item.ReplyType == 4 &&
                      item.language == this.languageActiveId &&
                      item.sameReplyAsNeutral == false
                    );
                  }),
                  ImageUrl: {
                    required: requiredIf(function(item) {
                      var validateFlag = this.form.intent.some((intent) => {
                        return intent.negativeReply.some((reply) =>
                          [3, 5].includes(reply.content.ReplyType)
                        );
                      });
                      return (
                        item &&
                        item.language == this.languageActiveId &&
                        validateFlag &&
                        item.sameReplyAsNeutral == false
                      );
                    }),
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  watch: {
    languageActiveId: function() {
      this.addLanguageForValidateBeforeCreate();
      this.$v.form.$reset();
    },
  },
  created: async function() {
    await this.getSuggestWordGroup();
    await this.getMasterData();
    this.onRemoveGroupKeyword(false);
  },
  methods: {
    onIntentTypeChange(val) {
      this.form.intentTypeId = val;
    },
    getSuggestWordGroup: async function() {
      await this.axios
        .post(`${this.$baseUrl}/suggestkeyword/list`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.groupList = data.detail ? data.detail : [];
          } else {
            this.groupList = [];
          }
        });
    },
    exportSuggestKeyword: async function() {
      const url = `${this.$baseUrl}/SuggestKeyword/export`;
      await this.axios
        .post(url, this.filter, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");
          var dateExcel = moment().format("DDMMYYYYhhmmss");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `Suggest Keyword -` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },
    setIsSentiment() {
      this.isSentiment = !this.isSentiment;
    },
    setSentimentActive(val) {
      this.sentimentActiveId = val;
    },
    setLanguageAvtive(val) {
      this.languageActiveId = val;
    },
    getMasterData: async function() {
      await this.getChanelList();
      await this.getTierList();
      await this.getIntentTypeList();
    },
    getIntentTypeList: async function() {
      await this.axios
        .get(`${this.$baseUrl}/flowBuilder/intentType`)
        .then((data) => {
          if (data.result == 1) {
            this.intentTypeList = data.detail;
          }
        });
    },
    getChanelList: async function() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/platform`)
        .then((data) => {
          if (data.result == 1) {
            this.channelList = data.detail;
          }
        });
    },
    getTierList: async function() {
      await this.axios.get(`${this.$baseUrl}/masterdata/tier`).then((data) => {
        if (data.result == 1) {
          this.tierList = data.detail;
        }
      });
    },
    onReloadSuggestKeyword: async function() {
      this.$v.form.$reset();
      this.idGroupKeyword.groupId = "";
      await this.getSuggestWordGroup();
    },
    handleCreateIntent(item) {
      this.setForm();
      this.isSentiment = false;
      this.sentimentActiveId = 1;
      this.intentLevel = 0;
      this.$v.form.$reset();
      this.idGroupKeyword.groupId = item.id;

      const languageFilter = this.languageList.filter((e) => {
        return e.id === this.languageActiveId;
      });
      this.languageList = languageFilter;
      this.form.intent.forEach((element) => {
        element.name = item.namekeyword;
        element.keyword.push(...item.word.map((e) => e.message));
      });
      this.form.intentButtonId = item.Id;
      this.$refs.sidebarIntent.show(true);
    },
    hadleModalAlertClose() {
      this.onReloadSuggestKeyword();
      this.$refs.sidebarIntent.hide(false);
    },
    createOrUpdateIntent() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        //if NegativeReply reply error set sentiment to 2
        this.form.intent.forEach((intent, index) => {
          intent.negativeReply.forEach((reply, rindex) => {
            if (
              this.$v.form.intent.$each.$iter[index].negativeReply.$each.$iter[
                rindex
              ].$error
            ) {
              this.sentimentActiveId = 2;
            } else {
              this.sentimentActiveId = 1;
            }
          });
        });
        return;
      } else {
        this.removeUnusedPropertyBeforeSubmit();
      }
    },
    addLanguageForValidateBeforeCreate() {
      this.form.intent.forEach((intent) => {
        //NeutralReply
        intent.neutralReply.forEach((neutral) => {
          if (neutral.content.text) {
            neutral.content.Text.Language = this.languageActiveId;
          }
          if (neutral.content.image) {
            neutral.content.Image.Language = this.languageActiveId;
          }
          if (neutral.content.button) {
            neutral.content.Button.forEach((button) => {
              button.language = intent.language;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.Language = this.languageActiveId;
          }
        });

        //NegativeReply
        intent.negativeReply.forEach((neutral) => {
          if (neutral.content.Text) {
            neutral.content.Text.Language = this.languageActiveId;
          }
          if (neutral.content.Image) {
            neutral.content.Image.Language = this.languageActiveId;
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              button.language = intent.language;
              button.setSameAsNeutralReply = intent.setSameAsNeutralReply;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.Language = this.languageActiveId;
          }
        });
      });
    },
    removeUnusedPropertyBeforeSubmit() {
      this.form.intent.forEach((intent) => {
        //clear word if not this.languageActiveId
        if (intent.language !== this.languageActiveId) {
          intent.keyword.splice(0, intent.keyword.length);
        }

        //NeutralReply
        intent.neutralReply.forEach((neutral) => {
          if (neutral.content.Text) {
            delete neutral.content.Text.language;
          }
          if (neutral.content.Image) {
            delete neutral.content.Image.language;
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              delete button.language;
            });
          }
          if (neutral.content.ReplyType == 4) {
            delete neutral.content.language;
          }
        });

        //NegativeReply
        intent.negativeReply.forEach((neutral) => {
          if (neutral.content.Text) {
            delete neutral.content.Text.language;
            delete neutral.content.Text.sameReplyAsNeutral;
          }
          if (neutral.content.Image) {
            delete neutral.content.Image.language;
            delete neutral.content.Image.setSameAsNeutralReply;
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              delete button.language;
              delete button.setSameAsNeutralReply;
            });
          }
          if (neutral.content.ReplyType == 4) {
            delete neutral.content.language;
            delete neutral.content.setSameAsNeutralReply;
          }
        });
      });

      this.submit();
    },
    submit: async function() {
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/flowBuilder/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
            this.onRemoveGroupKeyword(false);
          } else {
            this.modalErrorMessage = data.detail;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    onRemoveGroupKeyword: async function(isDisplayModal, groupId) {
      if (groupId) {
        this.idGroupKeyword.groupId = groupId;
      }
      if (isDisplayModal) {
        this.$refs.modalLoading.show();
      }
      
      let cancelToken = this.axios.CancelToken;
      const source = cancelToken.source();
      const timeout = setTimeout(() => {
        source.cancel();
        // Timeout Logic
      }, 10000);

      await this.axios
        .post(`${this.$baseUrl}/suggestkeyword/delete`, this.idGroupKeyword)
        .then((data) => {
          if (isDisplayModal) {
            if (data.result == 1) {
              this.modalMessage = "สำเร็จ";
              this.$refs.modalLoading.hide();
              this.$refs.modalAlert.show();
              this.getSuggestWordGroup();
            } else {
              this.modalErrorMessage = data.detail;
              this.$refs.modalLoading.hide();
              this.$refs.modalAlertError.show();
            }
          }
        });
    },
    onLanguageChange: async function(value) {
      this.filter.LanguageId = value;
      await this.getSuggestWordGroup();
    },
    onfilterChange: async function() {
      await this.getSuggestWordGroup();
    },
    getChanelList: async function() {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/platform`)
        .then((data) => {
          if (data.result == 1) {
            this.channelList = data.detail;
          }
        });
    },
    getTierList: async function() {
      await this.axios.get(`${this.$baseUrl}/masterdata/tier`).then((data) => {
        if (data.result == 1) {
          this.tierList = data.detail;
        }
      });
    },
    setForm() {
      (this.languageList = [
        {
          id: 1,
          name: "TH",
          isActive: true,
        },
        {
          id: 2,
          name: "EN",
          isActive: true,
        },
      ]),
        (this.form = {
          active: true,
          enableML: false,
          intentTypeId: 1,
          mainIntentId: 0,
          intentButtonId: 0,
          forwardToAgent: false,
          image: [],
          channel: [],
          tier: [],
          intent: [
            {
              intentId: 0,
              language: 1,
              name: "",
              sameReplyAsNeutral: true,
              keyword: [],
              neutralReply: [
                {
                  id: 0,
                  sortOrder: 1,
                  content: {
                    ReplyType: 1,
                    Text: {
                      Id: 0,
                      Text: "",
                      language: 1,
                      sameReplyAsNeutral: true,
                    },
                  },
                },
              ],
              negativeReply: [
                {
                  id: 0,
                  sortOrder: 1,
                  content: {
                    ReplyType: 1,
                    Text: {
                      Id: 0,
                      Text: "",
                      language: 1,
                      sameReplyAsNeutral: true,
                    },
                  },
                },
              ],
            },
            {
              intentId: 0,
              language: 2,
              name: "",
              sameReplyAsNeutral: true,
              keyword: [],
              neutralReply: [
                {
                  id: 0,
                  sortOrder: 1,
                  content: {
                    ReplyType: 1,
                    Text: {
                      Id: 0,
                      Text: "",
                      language: 2,
                      sameReplyAsNeutral: true,
                    },
                  },
                },
              ],
              negativeReply: [
                {
                  id: 0,
                  sortOrder: 1,
                  content: {
                    ReplyType: 1,
                    Text: {
                      Id: 0,
                      Text: "",
                      language: 2,
                      sameReplyAsNeutral: true,
                    },
                  },
                },
              ],
            },
          ],
        });
    },
  },
  computed: {
    filteredBarlists() {
      return this.groupList.filter((e) => {
        return e.languageId === this.filter.LanguageId;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-progress-container {
  overflow: hidden;
  overflow-y: auto;
}
.master-filter {
  min-width: 100px;
}

.custom-filter {
  justify-content: flex-end;
}

.button-export {
  background-color: transparent;
  color: #404040;
}

.button-export:hover {
  background-color: #7d6da8 !important;
  color: #fefefe;
}

@media screen and (max-width: 690px) {
  .custom-filter {
    justify-content: flex-start !important;
    margin: 1rem 0;
  }
}

@media screen and (max-width: 450px) {
  .custom-filter {
    flex-direction: column;
    margin: 1rem 0;
    gap: 1rem;
  }
}
</style>